import React from 'react';

const LoungeSVG = ({ width, height }) => (
	<svg
		width={width || '64px'}
		height={height || '55px'}
		viewBox="0 0 64 55"
		xmlSpace="preserve"
		id="lounge"
	>
		<g
			id="NEW-2"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Park"
				transform="translate(-553.000000, -4193.000000)"
				fill="#32C878"
				fill-rule="nonzero"
			>
				<g id="Group-19" transform="translate(187.000000, 4183.000000)">
					<g id="Group-34" transform="translate(298.000000, 10.000000)">
						<path
							d="M126.461538,21.409396 L125.230769,21.409396 L125.230769,5.53691275 C125.230769,2.46085011 122.769231,0 119.692308,0 L80.3076923,0 C77.2307692,0 74.7692308,2.46085011 74.7692308,5.53691275 L74.7692308,21.409396 L73.5384615,21.409396 C70.4615385,21.409396 68,23.9932886 68,26.9463087 L68,45.2796421 C68,47.3713647 69.7230769,49.0939597 71.8153846,49.0939597 L71.9384615,49.0939597 L71.9384615,55 L80.3076923,55 L80.3076923,49.0939597 L119.692308,49.0939597 L119.692308,55 L128.061538,55 L128.061538,49.0939597 L128.184615,49.0939597 C130.276923,49.0939597 132,47.3713647 132,45.2796421 L132,26.9463087 C132,23.9932886 129.538462,21.409396 126.461538,21.409396 Z M77.2307692,5.53691275 C77.2307692,3.81431767 78.5846154,2.46085011 80.3076923,2.46085011 L119.692308,2.46085011 C121.415385,2.46085011 122.769231,3.81431767 122.769231,5.53691275 L122.769231,21.409396 L121.292308,21.409396 C118.215385,21.409396 115.753846,23.8702461 115.753846,26.9463087 L115.753846,28.7919463 L84.3692308,28.7919463 L84.3692308,26.9463087 C84.3692308,23.8702461 81.9076923,21.409396 78.8307692,21.409396 L77.3538462,21.409396 L77.3538462,5.53691275 L77.2307692,5.53691275 Z M84.3692308,31.2527964 L115.753846,31.2527964 L115.753846,39.9888143 L84.3692308,39.9888143 L84.3692308,31.2527964 Z M77.8461538,52.6621924 L74.4,52.6621924 L74.4,49.2170022 L77.8461538,49.2170022 L77.8461538,52.6621924 Z M125.6,52.6621924 L122.153846,52.6621924 L122.153846,49.2170022 L125.6,49.2170022 L125.6,52.6621924 Z M129.538462,45.2796421 C129.538462,46.0178971 128.923077,46.6331096 128.184615,46.6331096 L128.061538,46.6331096 L119.692308,46.6331096 L80.3076923,46.6331096 L71.9384615,46.6331096 L71.8153846,46.6331096 C71.0769231,46.6331096 70.4615385,46.0178971 70.4615385,45.2796421 L70.4615385,26.9463087 C70.4615385,25.2237136 71.8153846,23.8702461 73.5384615,23.8702461 L74.7692308,23.8702461 L78.7076923,23.8702461 C80.4307692,23.8702461 81.7846154,25.2237136 81.7846154,26.9463087 L81.7846154,30.0223714 L81.7846154,31.2527964 L81.7846154,42.4496644 L118.092308,42.4496644 L118.092308,31.2527964 L118.092308,30.0223714 L118.092308,26.9463087 C118.092308,25.2237136 119.446154,23.8702461 121.169231,23.8702461 L125.107692,23.8702461 L126.338462,23.8702461 C128.061538,23.8702461 129.415385,25.2237136 129.415385,26.9463087 L129.415385,45.2796421 L129.538462,45.2796421 Z"
							id="Shape"
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default LoungeSVG;
